module.exports = __webpack_public_path__ + "static/media/communication-min.330a0731.jpg";